export enum RESTAURANT_CATEGORY_TYPE {
    INVALID = "RESTAURANT_CATEGORY_INVALID",
    GOURMET = "RESTAURANT_CATEGORY_GOURMET",
    FASTTRACK = "RESTAURANT_CATEGORY_FASTTRACK",
    HOMEMADE = "RESTAURANT_CATEGORY_HOMEMADE",
    DROPPT = "RESTAURANT_CATEGORY_DROPPT",
    BULKORDER = "RESTAURANT_CATEGORY_BULKORDER",
}
